// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"4deaf7a4","605":"b0cdeb2f","774":"daa67dd9","804":"0ba4018d","827":"c0cea293"}[chunkId] + ".chunk.js";
};